<template>
  <div>
    <div class="repertorymsg">
      <div class="msg">
        <i class="circle"></i>
        库存信息
      </div>
      <!-- <div class="datadetails">
        <span>
          空货位:
          <i></i>
        </span>
        <span>
          托盘组:
          <i></i>
        </span>
        <span>
          烟箱:
          <i></i>
        </span>
        <span>
          烟包:
          <i></i>
        </span>
      </div>-->
      <div class="datadetails">
        <span v-for="(item,index) in repertorymsg" :key="index">
          {{item.name}}:
          <i>{{item.value}}</i>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    // repertorymsg:{
    //     type:Object,
    //     default:()=> {
    //         return {
    //             place:"324",
    //             tray:"22",
    //             smokebox:"222",
    //             tobacco:"33"
    //         }
    //     }
    // }
    repertorymsg: {
      type: Array,
      default: () => {
        return [
          { value: "324", name: "空货位" },
          { value: "22", name: "托盘组" },
          { value: "222", name: "烟箱" },
          { value: "33", name: "烟包" }
        ];
      }
    }
  },
  name: "echarts28",
  data() {
    return {};
  }
};
</script>
<style scoped>
.repertorymsg {
  width: 302px;
  height: 150px;
  /* border: 2px solid #348692 */
  position: relative;
  border-radius: 4px;
  background-color: #00665E;
}
.msg {
  width: 100%;
  position: absolute;
  top: 10;
  line-height: 30px;
  left: 20px;
  font-size: 18px;
  color: #42beb6;
  border-radius: 4px;
  font-weight: 550;
}
.circle {
  background-color: #42beb6;
  border-radius: 4px;
  width: 8px;
  display: inline-block;
  height: 8px;
  margin-bottom: 2px;
}
.datadetails {
  position: absolute;
  width: 80%;
  left: 32px;
  height: 80px;
  top: 40px;
}
.datadetails span {
  width: 45%;
  display: inline-block;
  line-height: 30px;
  text-align: left;
  color: #02d19f;
  font-weight: 550;
}
.datadetails span i {
  color: #fff;
  font-weight: 550;
}
</style>


// WEBPACK FOOTER //
// src/components/xiayan/home/home/echarts28.vue